import { UrlDataWithMeta } from "./UrlDataWithMeta";

let id = 1000000;

export default function createUrl(initialUrl?: string): UrlDataWithMeta {
    const data: UrlDataWithMeta = {} as UrlDataWithMeta;
    data.id = `${--id}`;
    data.__action = "create";
    data.root_url = "";
    data.contains = "";
    if (initialUrl) {
        const domain = initialUrl?.includes("/")
            ? initialUrl?.substring(0, initialUrl.indexOf("/"))
            : initialUrl;
        const contains = initialUrl?.includes("/")
            ? initialUrl
                ?.substring(initialUrl.indexOf("/"))
                ?.replace(/^\/|\/$/g, "")
            : "";

        data.root_url = domain as string;
        data.contains = contains;
    }

    return data;
}